import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-admin-test',
  templateUrl: './admin-test.component.html',
  styleUrls: ['./admin-test.component.css']
})
export class AdminTestComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
